(function(){
  const drawer=document.querySelector('#shoe-drawer');
  const drawerButtons=document.querySelectorAll('[data-shop-drawer]');
  const searchDialog=document.querySelector('#site-search');

  drawerButtons.forEach(function(button){
    button.addEventListener('click',function(){
      if(!drawer||drawer.open)return;
      drawer.showModal();
      document.body.classList.add('shoe-drawer-open');
      drawerButtons.forEach(b=>b.setAttribute('aria-expanded','true'));
      drawer.querySelector('#shoe-drawer-close')?.focus();
    });
  });
  if(drawer){
    drawer.querySelector('#shoe-drawer-close')?.addEventListener('click',()=>drawer.close());
    drawer.addEventListener('close',function(){
      document.body.classList.remove('shoe-drawer-open');
      drawerButtons.forEach(b=>b.setAttribute('aria-expanded','false'));
    });
    drawer.addEventListener('click',event=>{if(event.target===drawer)drawer.close();});
  }

  document.querySelectorAll('[data-open-search]').forEach(button=>{
    button.addEventListener('click',function(){
      if(!searchDialog||searchDialog.open)return;
      if(drawer?.open)drawer.close();
      searchDialog.showModal();
      searchDialog.querySelector('input[name="q"]')?.focus();
    });
  });
  if(searchDialog){
    searchDialog.querySelector('[data-close-search]')?.addEventListener('click',()=>searchDialog.close());
    searchDialog.addEventListener('click',event=>{if(event.target===searchDialog)searchDialog.close();});
  }
  document.querySelectorAll('[data-language-select]').forEach(select=>select.addEventListener('change',()=>select.form.submit()));
})();
